import React, { useEffect, useState } from "react";
import EmployeeMultiSelect from "../../../components/EmployeeMultiSelect";
import { Link } from "react-router-dom";
import { Pagination, Table } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import config from "../../../config";
import EditCandidatesModal from "../../../components/Administration/Jobs/CandidatesModal/EditCandidatesModal";
import { useRefresh } from "../../../context/RefreshContext";
import User from "../../../assets/img/icons/user3.png";
import { companyID, getEmployeeLocalDetails } from "./../../../auth";
import ProtectedButton from "../../../Routes/Approuter/ProtectedButton";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SalaryDetail from "../../../components/SalaryDetail";
import AcknowledgmentPopup from "../../../utils/AcknowledgmentPopup";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { getFile } from "../../../utils/getFile";
import { useTranslation } from "react-i18next";
import TerminationModal from "../../../components/modelpopup/TerminationModal";
import FilterComponent from "../../../components/FilterComponent";
import TooltipWrapper from "../../../utils/TooltipWrapper";
import { getDepartmentById } from "../../../services/departmentService";
import { encrypt } from "../../../utils/crypto";
import PipActivationModal from "../HR/PIP/PipActivationModal";
// import DeleteModal from './../../../components/modelpopup/deletePopup';
import { Loader } from "react-feather";
import { applyForResignationWithdrawal } from "../../../services/ResignationServices";
import TerminateEmployeeModal from "../../../components/modelpopup/TerminateEmployeeModal";
import EmployeeLocationModal from "../HR/EmployeeLocations/EmployeeLocationModal";
import UserTrackingModal from "../HR/EmployeeLocations/UserTrackingModal";
import WorkDateSelector from "../Profile/WorkDateSelector";
import { useEmployees } from "../../../hooks/useEmployees";
import { sendSalaryAcknowledgment } from "../../../services/salaryServices";
import BulkGenerateSalaryModal from "../../../components/BulkGenerateSalaryModal";
import EmployeeHoursModal from "../../../components/modelpopup/EmployeeHoursModal";

const EmployeeList = () => {
  const { t } = useTranslation();
  const [paginationValue, setPaginationValue] = useState(12);
  const [employeeData, setEmployeeData] = useState([]);
  const [deletedId, setDeletedID] = useState("");
  const [renderState, setRenderState] = useState(false);
  const [res, setRes] = useState({});
  const [fieldFour, setFieldFour] = useState(false);
  const [fieldOne, setFieldOne] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeletedTrue, setIsDeletedTrue] = useState(false);
  const [showAcknowledgmentPopup, setShowAcknowledgmentPopup] = useState(false);
  const [showPipActivationModal, setShowPipActivationModal] = useState(false);
  const [terminationData, setTerminationData] = useState({})
  const [acknowledgmentPopup, setAcknowledgmentPopup] = useState({
    popupVariant: "",
    popupMessage: "",
    popupIcon: "",
  });
  const [showModalTermination, setShowModalTermination] = useState(false);
  const [showBulkSalaryModal, setShowBulkSalaryModal] = useState(false);
  const [imageMap, setImageMap] = useState({});
  const [currentEmployees, setCurrentEmployees] = useState([]);
  const [showTerminationModal, setShowTerminationModal] = useState(false);
  const [showHoursModal, setShowHoursModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [filterOptions, setFilterOptions] = useState([
    { key: "Active", label: "status", value: [1], category: "Status" },
    { key: "Inactive", label: "status", value: [0], category: "Status" },
    { key: "All Employees", label: "status", value: null, category: "Status" },
    {
      key: "Pending",
      label: "onboarding",
      value: ["PENDING"],
      category: "Onboarding status",
    },
    {
      key: "Completed",
      label: "onboarding",
      value: ["COMPLETED"],
      category: "Onboarding status",
    },
    {
      key: "All",
      label: "onboarding",
      value: null,
      category: "Onboarding status",
    },
  ]);

  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const { options: employeeOptions, loading: loadingEmployees } = useEmployees({ status: 1 });

  const employeeDetails = getEmployeeLocalDetails();

  const handleShowTermination = (detail) => {
    setShowTerminationModal(true);
    setSelectedEmployee(detail);
  };
  const handleShowPIP = (detail) => {
    setShowPipActivationModal(true);
    setSelectedEmployee(detail);
  };
  const handleClosePIP = () => {
    setShowPipActivationModal(false);
    setSelectedEmployee({});
  };
  const handleCloseTermination = () => {
    setShowTerminationModal(false);
    setSelectedEmployee({});
  };
  const handleShowHours = (detail) => {
    setSelectedEmployee(detail);
    setShowHoursModal(true);
  };
  const handleCloseHours = () => {
    setShowHoursModal(false);
    setSelectedEmployee({});
  };
  const { refresh } = useRefresh();

  useEffect(() => {
    if (isModalOpen || isEditModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [isModalOpen, isEditModalOpen]);

  const handleDelete = (id) => {
    setDeletedID(id);
  };

  const loginEmployeeId = localStorage.getItem("employeeID");
  const company_id = companyID();
  const [employeeDetailsError, setEmployeeDetailsError] = useState(null);

  const fetchCompanyEmployees = async (params = { status: 1 }) => {
    if (
      !employeeDetails ||
      !employeeDetails.employee_role ||
      (employeeDetails.employee_role != 1 &&
        !employeeDetails.working_departments?.length)
    ) {
      setEmployeeDetailsError("No employees found as you are not assigned to any department.");
      setEmployeeData([]);
      return;
    }
    setEmployeeDetailsError(null);

    let finalParams = { ...params };
    console.log("finalParams", finalParams);
    //  if(localStorage.getItem("employee_role") != 1){
    //        if(finalParams?.department_id?.length == 0){
    //         console.log("No employees found as you are not assigned to any department.")

    //           setEmployeeData([]);
    //           return;
    //        } 
    //  }

    try {
      if (
        employeeDetails.employee_role != 1 &&
        employeeDetails.working_departments?.length
      ) {
        if (!("department_id" in finalParams))
          finalParams.department_id = employeeDetails.working_departments;
      }

      // Add selected employee IDs to the filter
      if (selectedEmployeeIds.length > 0) {
        finalParams.employee_id = selectedEmployeeIds;
      }

      const queryParams = new URLSearchParams();
      Object.entries(finalParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            if (val !== null && val !== undefined && val !== "") {
              queryParams.append(key, val);
            }
          });
        } else {
          queryParams.append(key, value);
        }
      });

      const response = await api.get(
        `employees/employeeDetails/${company_id}?${queryParams.toString()}`
      );

      if (!Array.isArray(response?.data)) {
        console.error("Invalid data format received:", response);
        setEmployeeData([]);
        return;
      }

      const excludedEmploymentStatuses = new Set(["separated", "terminated"]);

      const isInactiveFilter =
        finalParams.status === 0 ||
        (Array.isArray(finalParams.status) && finalParams.status.includes(0));

      const isAllFilter =
        finalParams.status === null ||
        finalParams.status === undefined ||
        (Array.isArray(finalParams.status) && finalParams.status.every((v) => v === null));

      const filteredResponse = response.data.filter((item) => {
        const employmentStatus = String(item.employment_status || "").toLowerCase();

        if (selectedEmployeeIds.includes(item.id)) {
          return true;
        }

        if (isAllFilter) {
          return true;
        }

        if (isInactiveFilter) {
          return true;
        }

        if (excludedEmploymentStatuses.has(employmentStatus)) {
          return false;
        }

        return true;
      });


      const filteredData = filteredResponse.map((item) => ({
        ...item,
        first_name: item.first_name ?? "",
        middle_name: item.middle_name ?? "",
        last_name: item.last_name ?? "",
        official_email: item.official_email ?? "-",
        photo: item.photo ?? "",
        number: item.number ?? "-",
        department_id: item.department_id ?? "",
        designation_id: item.designation_id ?? "",
        department_name: item.department_name ?? "-",
        designation_name: item.designation_name ?? "-",
        status: item.status,
      }));

      setEmployeeData(filteredData);
    } catch (error) {
      console.error("Error fetching company employees:", error);
      setEmployeeData([]);
    } finally {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (company_id) {
      fetchCompanyEmployees();
    }
  }, [refresh, renderState, isDeletedTrue]);

  const employmentStatusColor = {
    probationary: "secondary",
    permanent: "success",
    terminated: "danger",
    separated: "danger",
    intern: "info",
    on_notice: "warning",
    PIP: "danger",
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      render: (text, record) => {
        const encryptedEmployeeId = encrypt(record.id);
        return (
          <span className="table-avatar">
            <Link to={`profile/${encryptedEmployeeId}`} className="avatar">
              <span>
                <img
                  alt=""
                  src={imageMap[record.id] || User}
                  style={{ borderRadius: "50%" }}
                />
              </span>
            </Link>
            <Link to={`profile/${encryptedEmployeeId}`}>
              <span>
                {record?.first_name} {record?.middle_name} {record?.last_name}
              </span>
            </Link>
          </span>
        );
      },
    },

    {
      title: t("Email"),
      dataIndex: "official_email",
    },

    {
      title: t("Mobile"),
      dataIndex: "number",
    },
    {
      title: t("Department"),
      dataIndex: "department_name",
    },
    {
      title: t("Designation"),
      dataIndex: "designation_name",
    },
    {
      title: t("Employment status"),
      dataIndex: "employment_status",
      render: (text, record) => {
        const employmentStatus = record.employment_status || "-";
        const statusColor =
          employmentStatusColor[record?.employment_status] || "secondary";
        return (
          <span className={`badge bg-${statusColor}`}>
            {employmentStatus
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </span>
        );
      },
    },
    {
      title: t("Status"),
      render: (text, record) => {
        const status = record.status == 1;
        return (
          <span className={`badge bg-${status ? "success" : "danger"}`}>
            {status ? t("Active") : t("Inactive")}
          </span>
        );
      },
    },
    {
      title: t("Action"),
      render: (text, record) => {
        const deactivate = record?.status == "1" ? false : true;
        const employmentStatus = String(record?.employment_status || "").toLowerCase();
        const showSalaryAction = !["terminated", "separated"].includes(employmentStatus);
        const onboardingCompleted = Number(record?.onboarding_completed) === 1;
        return (
          <div className="action-menu text-end">
            <div className="d-flex gap-2 mt-2">
              <ProtectedButton page="employees" action="edit">
                <button
                  className="list-group-item list-group-item-action"
                  disabled={deactivate}
                  onClick={(e) => {
                    e.preventDefault();
                    editHandler(record.id);
                    setIsEditModalOpen(true);
                  }}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip
                        id="tooltip-view"
                        style={{ fontSize: "12px", padding: "2px" }}
                      >
                        {t("Edit Employee")}
                      </Tooltip>
                    }
                  >
                    <i
                      className={`fa fa-pencil m-r-5 text-${deactivate ? "secondary" : "info"
                        }`}
                    />
                  </OverlayTrigger>
                </button>
              </ProtectedButton>
              <button
                className="list-group-item list-group-item-action"
                data-bs-toggle="modal"
                data-bs-target="#delete_employee"
                disabled={deactivate || record.id === Number(loginEmployeeId)}
                onClick={() => handleDelete(record.id)}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("Deactivate Employee")}
                    </Tooltip>
                  }
                >
                  <i
                    className={`fa-solid fa-power-off text-${deactivate || record.id !== Number(loginEmployeeId)
                      ? "success"
                      : "secondary"
                      }`}
                  ></i>
                </OverlayTrigger>
              </button>
              {!onboardingCompleted ? (
                <Link
                  className="list-group-item list-group-item-action"
                  to={`../employee-onboarding-details/${encrypt(record.id)}`}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip
                        id="tooltip-view"
                        style={{ fontSize: "12px", padding: "2px" }}
                      >
                        {t("Verify Onboarding")}
                      </Tooltip>
                    }
                  >
                    <i className="fa-solid fa-user-check text-primary"></i>
                  </OverlayTrigger>
                </Link>
              ) : (
                <>
              <button
                className="list-group-item list-group-item-action"
                disabled={
                  deactivate ||
                  (record.id === Number(loginEmployeeId) &&
                    record?.resignation_status == null)
                }
                onClick={() => handleShowTermination(record)}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("Terminate Employee")}
                    </Tooltip>
                  }
                >
                  <i
                    className={`fa-solid fa-ban text-${deactivate ||
                      (record.id !== Number(loginEmployeeId) &&
                        record?.resignation_status == null)
                      ? "danger"
                      : "secondary"
                      }`}
                  ></i>
                </OverlayTrigger>
              </button>

              {showSalaryAction && (
                <button
                  className="list-group-item list-group-item-action"
                  disabled={deactivate}
                  onClick={() => {
                    setEmployId(record.id);
                    handleShowModal();
                  }}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip
                        id="tooltip-view"
                        style={{ fontSize: "12px", padding: "2px" }}
                      >
                        {t("Generate Salary")}
                      </Tooltip>
                    }
                  >
                    <i
                      className={`fa-solid fa-receipt text-${deactivate ? "secondary" : "success"
                        }`}
                    ></i>
                  </OverlayTrigger>
                </button>
              )}

              {record?.employment_type === "hourly" && (
                <ProtectedButton page="employees-salary" action={["all", "create"]}>
                  <button
                    className="list-group-item list-group-item-action"
                    disabled={deactivate}
                    onClick={() => handleShowHours(record)}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip
                          id="tooltip-view"
                          style={{ fontSize: "12px", padding: "2px" }}
                        >
                          {t("Employee Hours")}
                        </Tooltip>
                      }
                    >
                      <i
                        className={`fa-solid fa-clock text-${deactivate ? "secondary" : "primary"
                          }`}
                      ></i>
                    </OverlayTrigger>
                  </button>
                </ProtectedButton>
              )}

              {!showSalaryAction && (
                <ProtectedButton page="employee-fnf" action={["all", "create"]}>
                  <Link
                    className="list-group-item list-group-item-action"
                    to={`../employee-fnf`}
                    state={{ employeeId: record.id }}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip
                          id="tooltip-view"
                          style={{ fontSize: "12px", padding: "2px" }}
                        >
                          {t("View FNF")}
                        </Tooltip>
                      }
                    >
                      <i className="fa-solid fa-handshake text-success"></i>
                    </OverlayTrigger>
                  </Link>
                </ProtectedButton>
              )}

              <button
                className="list-group-item list-group-item-action"
                disabled={record?.employment_status == 'permanent' || record?.employment_status == 'probationary'
                  ? record?.status == "1" && record.id !== Number(loginEmployeeId) &&
                    record?.employment_status !== "PIP" ? false : true : true
                }
                onClick={() => {
                  handleShowPIP(record);
                }}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("PIP")}
                    </Tooltip>
                  }
                >
                  <i
                    className={`fa-solid fa-chart-line text-${record?.employment_status == 'permanent' || record?.employment_status == 'probationary'
                      ? record?.status == "1" && record.id !== Number(loginEmployeeId) &&
                        record?.employment_status !== "PIP" ? "danger" : "secondary" : "secondary"

                      }`}
                  ></i>
                </OverlayTrigger>
              </button>


              <button
                className="list-group-item list-group-item-action"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowLocationModal(record);
                }}
              >

                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("Employee Location")}
                    </Tooltip>
                  }
                >
                  <i className="fa-solid fa-location-dot text-danger"></i>
                </OverlayTrigger>
              </button>

              <button
                className="list-group-item list-group-item-action"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowWorkRequestSettings(record);
                }}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("Work Mode")}
                    </Tooltip>
                  }
                >
                  <i className="fa-solid fa-location-crosshairs text-primary"></i>
                </OverlayTrigger>
              </button>

              <button
                className="list-group-item list-group-item-action"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowUserTrackingModal(record);
                }}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {t("User Tracking Details")}
                    </Tooltip>
                  }
                >
                  <i className="fa-solid fa-user-clock text-info"></i>
                </OverlayTrigger>
              </button>
                </>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  const [employID, setEmployId] = useState("");
  const [selectedEmployeeName, setSelectedEmployeeName] = useState("");
  const editHandler = async (id) => {
    setEmployId(id);
    const res = await api.get(`employees/${id}`);
    setRes(res);
  };

  const confirmDelete = async () => {
    try {
      if (deletedId) {
        const response = await api.put(
          `employees/delete-employee/${deletedId}`,
          {}
        );
        if (response?.data?.success == true) {
          setDeletedID(null);
          setEmployeeData((prev) =>
            prev.filter((employee) => employee.id != deletedId)
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openModal = async () => {
    const company_id = companyID();
    try {
      const response = await api.get(`subscriptions/subscription-limit?company_id=${company_id}`);
      if (response?.data?.data?.canAddEmployee) {
        setIsModalOpen(true);
      }
      else {
        toast.error(`You have only ${response?.data?.data?.totalPersonsAllowed} user account according to the subscription plan. If you want to add more, please connect with HRGlobes Support.`);
        setIsModalOpen(false);
      }
    }
    catch (error) {
      console.log(error);
    }

  };

  const [listView, setListView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [terminationLoading, setTerminationLoading] = useState(false);

  useEffect(() => {
    const startIndex = (currentPage - 1) * paginationValue;
    const endIndex = startIndex + paginationValue;
    const employees = employeeData?.slice(startIndex, endIndex);

    setCurrentEmployees(employees);
  }, [employeeData, currentPage]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPaginationValue(pageSize);
  };

  /** Salary detail Modal Start*/

  const [showModal, setShowModal] = useState(false);
  const [salaryModalLoading, setSalaryModalLoading] = useState(true);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setEmployId("");
    setSelectedEmployeeName("");
  };

  const [employeeLoationDetails, setEmployeeLoactionDetails] = useState(null);
  const [showEmployeeLocationModal, setShowEmployeeLocationModal] = useState(false);
  const [workRequestEmployeeId, setWorkRequestEmployeeId] = useState("");
  const [workRequestDates, setWorkRequestDates] = useState([]);
  const [openWorkRequestModal, setOpenWorkRequestModal] = useState(
    () => () => { },
  );

  const handleShowLocationModal = (record) => {
    setEmployeeLoactionDetails(record);
    setShowEmployeeLocationModal(true);
  }
  const handleCloseLocationModal = () => {
    setShowEmployeeLocationModal(false);
  }

  const [userTrackingDetails, setUserTrackingDetails] = useState(null);
  const [showUserTrackingModal, setShowUserTrackingModal] = useState(false);
  const handleShowUserTrackingModal = (record) => {
    setUserTrackingDetails(record);
    setShowUserTrackingModal(true);
  }
  const handleCloseUserTrackingModal = () => {
    setShowUserTrackingModal(false);
  }

  const handleShowWorkRequestSettings = async (record) => {
    setWorkRequestEmployeeId(record?.id || "");
    try {
      const approved = "rejected";
      const response = await api.get(
        `/api/profile?employee_id=${record?.id}&login_status=${approved}`,
      );
      setWorkRequestDates(response?.data?.data?.wfhDates || []);
    } catch (error) {
      console.error("Error fetching work request dates:", error);
      setWorkRequestDates([]);
      toast.error("Unable to load work request dates.");
    } finally {
      openWorkRequestModal();
    }
  };
  const saveSalary = (employee_id, salaryStructure, salary_slip) => {
    api
      .post(`generate-salary`, {
        employee_id: employee_id,
        month: salaryStructure.salaryMonth,
        ...salaryStructure,
        salary_slip: salary_slip,
        created_by: loginEmployeeId,
        updated_by: loginEmployeeId,
      })
      .then((res) => { })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => { });
  };

  const handleGenerateSalary = (formData, notifySalaryAcknowledgment = false) => {
    setSalaryModalLoading(true);
    api
      .post(`generate-pdf`, formData)
      .then(async (res) => {
        const { fileName } = res?.data?.result;
        saveSalary(formData.employee_id, formData, fileName);
        if (notifySalaryAcknowledgment) {
          try {
            const acknowledgmentData = {
              employees: [
                {
                  value: formData.employee_id,
                  label: formData.employee_name || selectedEmployeeName || "",
                },
              ],
              yearMonth: formData.salaryMonth,
              notify_by: loginEmployeeId,
              companyId: company_id,
            };
            await sendSalaryAcknowledgment(acknowledgmentData);
          } catch (error) {
            console.error(error);
            toast.error("Failed to send salary acknowledgment.");
          }
        }
        toast.success("Salary Generated");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong, please try again later.");
      })
      .finally(() => {
        setSalaryModalLoading(false);
        handleCloseModal();
      });
  };

  /** Salary detail Modal End*/

  useEffect(() => {
    const fetchImages = async () => {
      const newImageMap = {};
      for (const employee of currentEmployees) {
        if (employee.photo) {
          const imageUrl = await getFile(
            `${config.IMAGE_URL}${employee.photo}`
          );
          if (imageUrl) {
            newImageMap[employee.id] = imageUrl;
          }
        }
      }
      setImageMap(newImageMap);
    };

    fetchImages();
  }, [currentEmployees]);

  const fetchDepartments = async () => {
    try {
      const departments = await getDepartmentById(company_id);
      if (!departments?.result?.length) {
        return;
      }
      const mappedDepartments = departments.result
        .filter((dept) => {
          if (
            employeeDetails.employee_role != 1 &&
            employeeDetails.working_departments?.length
          ) {
            return employeeDetails?.working_departments?.includes(dept.id);
          } else if (employeeDetails.employee_role == 1) {
            return true;
          } else {
            return false;
          }
        })
        .map((dept) => ({
          key: dept.department_name,
          label: "department_id",
          value: dept.id,
          category: "Department",
        }));

      setFilterOptions((prevOptions) => [...prevOptions, ...mappedDepartments]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });


  const withdrawSeparation = async () => {
    console.log("terminationData", terminationData);
    try {
      setTerminationLoading(true);
      setLoading((prev) => ({
        ...prev,
        show: true,
        message: "Withdrawing Termination...",
      }));

      const response = await applyForResignationWithdrawal(
        terminationData?.resignation_id,
        loginEmployeeId, "termination", terminationData?.id
      );
      if (response?.success) {
        toast.success("Termination withdrawal successful");


        fetchCompanyEmployees();
      } else {
        toast.error(response?.message || "Failed to withdraw Termination");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong, please try again later!");
    } finally {

      setShowModalTermination(false)
      setTerminationLoading(false);
      setLoading((prev) => ({
        ...prev,
        show: false,
        message: "",
      }));
    }
  };

  // Refetch employees when selection changes
  useEffect(() => {
    if (company_id) {
      fetchCompanyEmployees();
    }
  }, [selectedEmployeeIds]);

  return (
    <div>
      <div className="page-wrapper" style={{ position: "relative" }}>
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={t("Employee")}
            title={t("Dashboard")}
            subtitle={t("Employee")}
            name={t("Add Employee")}
            openModal={openModal}
            page="employees"
            action="create"
          />
          {/* /Page Header */}
          {/* <EmployeeListFilter /> */}
          <div className="d-flex justify-content-end gap-2 mb-3 flex-wrap">
            <div style={{ width: "280px", position: "relative" }}>
              <EmployeeMultiSelect
                options={employeeOptions}
                selectedValues={selectedEmployeeIds}
                onChange={setSelectedEmployeeIds}
                placeholder="Select Employees..."
                loading={loadingEmployees}
              />
            </div>

            {/* Bulk Generate Salary button */}
            {/* <TooltipWrapper tooltipText="Bulk Generate Salary for multiple employees">
              <button
                id="bulk-generate-salary-btn"
                className="btn btn-outline-primary"
                style={{ height: 'fit-content' }}
                onClick={() => setShowBulkSalaryModal(true)}
              >
                <i className="fa-solid fa-money-check-dollar me-1" />
                Bulk Salary
              </button>
            </TooltipWrapper> */}

            <SearchBox
              setPaginationValue={setPaginationValue}
              setListView={setListView}
              listView={listView}
            />

            <TooltipWrapper tooltipText="Filter">
              <FilterComponent
                filterOptions={filterOptions}
                onApplyFilter={(selectedFilter) => {
                  const queryParams = { ...selectedFilter };
                  if (!queryParams.status?.length) {
                    queryParams.status = [1];
                  }
                  fetchCompanyEmployees(queryParams);
                }}
                filterLabel="Filter Employees"
                resetLabel="Reset Filter"
                applyLabel="Apply"
              />
            </TooltipWrapper>
          </div>
          {listView ? (
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <Table
                    className="table-striped"
                    columns={columns}
                    dataSource={employeeData}
                    rowKey={(record) => record.id}
                    pagination={{ pageSize: paginationValue }}
                    scroll={{ x: true }}
                    tableLayout="auto"
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                {currentEmployees?.length ? (
                  currentEmployees.map((employee) => {
                    const statusColor =
                      employmentStatusColor[employee?.employment_status] ||
                      "secondary";
                    const encryptedEmployeeId = encrypt(employee.id);
                    const onboardingCompleted =
                      Number(employee?.onboarding_completed) === 1;

                    return (
                      <div
                        className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                        key={employee.id}
                      >
                        <div className="profile-widget overflow-visible">
                          <div className="profile-img">
                            <Link
                              to={`profile/${encryptedEmployeeId}`}
                              className="avatar"
                            >
                              <img
                                src={imageMap[employee.id] || User}
                                alt="Employee"
                              />
                            </Link>
                          </div>
                          <div className="dropdown profile-action">
                            <Link
                              to="#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="material-icons">more_vert</i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                              <ProtectedButton page="employees" action="edit">
                                <button
                                  className="dropdown-item"
                                  to="#"
                                  disabled={
                                    employee?.status == "1" ? false : true
                                  }
                                  onClick={(e) => {
                                    e.preventDefault();
                                    editHandler(employee.id);
                                    setIsEditModalOpen(true);
                                  }}
                                >
                                  <i className="fa fa-pencil m-r-5 text-info" />{" "}
                                  {t("Edit")}
                                </button>
                              </ProtectedButton>
                              {employee.id !== Number(loginEmployeeId) && (
                                <button
                                  className="dropdown-item"
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete_employee"
                                  disabled={
                                    employee?.status == "1" ? false : true
                                  }
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDelete(employee.id);
                                  }}
                                >
                                  <i
                                    className={`fa-solid fa-power-off text-${employee?.status == "1"
                                      ? "success"
                                      : "secondary"
                                      }`}
                                  ></i>{" "}
                                  {t("Deactivate")}
                                </button>
                              )}
                              {!onboardingCompleted ? (
                                <Link
                                  className="dropdown-item"
                                  to={`../employee-onboarding-details/${encryptedEmployeeId}`}
                                >
                                  <i className="fa-solid fa-user-check text-primary" />{" "}
                                  {t("Verify Onboarding")}
                                </Link>
                              ) : (
                                <>
                              <ProtectedButton page="pip" action={["all", "create"]}>
                                {employee.id !== Number(loginEmployeeId) &&
                                  employee?.employment_status !== "PIP" && (
                                    <button
                                      className="dropdown-item"
                                      to="#"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#delete_employee"
                                      disabled={
                                        employee?.status == "1" ? false : true
                                      }
                                      onClick={() => {
                                        handleShowPIP(employee);
                                      }}
                                    >
                                      <i
                                        className={`fa-solid fa-chart-line text-${employee?.status == "1"
                                          ? "danger"
                                          : "secondary"
                                          }`}
                                      ></i>{" "}
                                      {t("PIP - (Performance Improvement)")}
                                    </button>
                                  )}
                              </ProtectedButton>
                              <ProtectedButton page="employees-resignation" action={["all", "create"]}>
                                {employee.id !== Number(loginEmployeeId) &&
                                  employee?.resignation_status == null ? (
                                  <button
                                    className="dropdown-item"
                                    disabled={
                                      employee?.status == "1" ? false : true
                                    }
                                    onClick={() => {
                                      handleShowTermination(employee);
                                    }}
                                  >
                                    <i
                                      className={`fa-solid fa-ban text-${employee?.status == "1"
                                        ? "danger"
                                        : "secondary"
                                        }`}
                                    ></i>{" "}
                                    {t("Terminate")}
                                  </button>) : employee?.employment_status == "terminated" && <button
                                    className="dropdown-item"
                                    //               data-bs-toggle="modal"
                                    // data-bs-target="#terminate_employee"
                                    disabled={
                                      employee?.status == "1" ? false : true
                                    }
                                    onClick={() => {
                                      setTerminationData(employee);
                                      setShowModalTermination(true);
                                    }}
                                  >
                                    <i
                                      className={`fa-solid fa-ban text-${employee?.status == "1"
                                        ? "danger"
                                        : "secondary"
                                        }`}
                                    ></i>{" "}
                                    {t("Revoke Termination")}
                                  </button>
                                }
                              </ProtectedButton>
                              {!(["terminated", "separated"].includes(String(employee?.employment_status || "").toLowerCase())) && (
                                <ProtectedButton page="employees-salary" action={["all", "create"]}>
                                  <button
                                    className="dropdown-item"
                                    to="#"
                                    disabled={
                                      employee?.status == "1" ? false : true
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEmployId(employee.id);
                                      setSelectedEmployeeName(
                                        `${employee?.first_name || ""} ${employee?.middle_name || ""
                                          } ${employee?.last_name || ""}`.trim()
                                      );
                                      handleShowModal();
                                    }}
                                  >
                                    <i className="fa-solid fa-receipt text-success" />{" "}
                                    {t("Generate Salary")}
                                  </button>
                                </ProtectedButton>
                              )}
                              {employee?.employment_type === "hourly" && (
                                <ProtectedButton page="employees-salary" action={["all", "create"]}>
                                  <button
                                    className="dropdown-item"
                                    to="#"
                                    disabled={
                                      employee?.status == "1" ? false : true
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleShowHours(employee);
                                    }}
                                  >
                                    <i
                                      className={`fa-solid fa-clock text-${employee?.status == "1"
                                        ? "primary"
                                        : "secondary"
                                        }`}
                                    ></i>{" "}
                                    {t("Employee Hours")}
                                  </button>
                                </ProtectedButton>
                              )}
                              {(["terminated", "separated"].includes(String(employee?.employment_status || "").toLowerCase())) && (
                                <ProtectedButton page="employee-fnf" action={["all", "create"]}>
                                  <Link
                                    className="dropdown-item"
                                    to={`../employee-fnf`}
                                    state={{ employeeId: employee.id }}
                                  >
                                    <i className="fa-solid fa-handshake text-success" />{" "}
                                    {t("View FNF")}
                                  </Link>
                                </ProtectedButton>
                              )}
                              <ProtectedButton page="performance-bonus/:employee_id" action={["all", "create"]}>
                                <Link
                                  className="dropdown-item"
                                  to={`../performance-bonus/${encryptedEmployeeId}`}
                                  state={{ employee }}
                                  disabled={
                                    employee?.status == "1" ? false : true
                                  }
                                >
                                  <i className="fa-solid fa-gift text-primary" />{" "}
                                  {t("Performance Bonus")}
                                </Link>
                              </ProtectedButton>
                              <ProtectedButton page="employee-locations" action={["all", "create"]}>
                                <button
                                  className="dropdown-item"
                                  to="#"

                                  onClick={(e) => {
                                    e.preventDefault();

                                    handleShowLocationModal(employee);
                                  }}
                                >
                                  <i className="fa-solid fa-location-dot text-danger"></i>{" "}

                                  {t("Employee Location")}
                                </button>

                                <button
                                  className="dropdown-item"
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowWorkRequestSettings(employee);
                                  }}
                                >
                                  <i className="fa-solid fa-location-crosshairs text-primary"></i>{" "}
                                  {t("Work Mode")}
                                </button>

                                <button
                                  className="dropdown-item"
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowUserTrackingModal(employee);
                                  }}
                                >
                                  <i className="fa-solid fa-user-clock text-info"></i>{" "}
                                  {t("User Tracking Details")}
                                </button>
                              </ProtectedButton>
                                </>
                              )}
                            </div>
                          </div>
                          <h4 className="user-name m-t-10 mb-0 text-ellipsis">
                            <Link to={`profile/${encryptedEmployeeId}`}>
                              {employee?.first_name} {employee?.middle_name}{" "}
                              {employee?.last_name}
                            </Link>
                          </h4>
                          <div className="small text-muted">
                            {employee?.designation_name
                              ? employee?.designation_name
                              : "-"}
                          </div>
                          {employee?.employment_status ? (
                            <span className={`badge bg-${statusColor} mt-2`}>
                              {employee?.employment_status
                                .split("_")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center mt-2">
                    <i className="fa fa-folder-open fa-3x text-muted mb-3"></i>
                    {/* <p className="text-muted">{t("No data")}</p> */}
                    {employeeDetailsError && <p className="text-muted">{t(employeeDetailsError)}</p>}
                  </div>
                )}
              </div>
              {employeeData.length ? (
                <div className="d-flex justify-content-end mb-4">
                  <Pagination
                    current={currentPage}
                    pageSize={paginationValue}
                    total={employeeData.length}
                    onChange={handlePageChange}
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
        {/* /Page Content */}
        {isEditModalOpen && (
          <EditCandidatesModal
            employID={employID}
            setRenderState={setRenderState}
            fieldOne={fieldOne}
            setFieldOne={setFieldOne}
            fieldFour={fieldFour}
            setFieldFour={setFieldFour}
            res={res}
            isEditModalOpen={isEditModalOpen}
            setIsEditModalOpen={setIsEditModalOpen}
          />
        )}
        <AllEmployeeAddPopup
          setEmployeeData={setEmployeeData}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
        />
        <DeleteModal
          Name="Deactivate Employee"
          confirmDelete={confirmDelete}
          btnName={"Deactivate"}
        />
        {showAcknowledgmentPopup ? (
          <AcknowledgmentPopup
            popupVariant={acknowledgmentPopup.popupVariant}
            popupMessage={acknowledgmentPopup.popupMessage}
            popupIcon={acknowledgmentPopup.popupIcon}
          />
        ) : (
          <></>
        )}
      </div>
      {/** Salary detail Modal */}
      <SalaryDetail
        employeeId={employID}
        show={showModal}
        handleClose={handleCloseModal}
        handleGenerate={handleGenerateSalary}
        loading={salaryModalLoading}
        setLoading={setSalaryModalLoading}
        employeeName={selectedEmployeeName}
      />
      {/** Salary detail Modal */}
      {(isModalOpen || isEditModalOpen) && (
        <div className="modal-backdrop fade show"></div>
      )}
      {showTerminationModal && (
        <TerminationModal
          show={showTerminationModal}
          handleClose={handleCloseTermination}
          selectedEmployee={selectedEmployee}
        />
      )}
      {showPipActivationModal && (
        <PipActivationModal
          show={showPipActivationModal}
          handleClose={handleClosePIP}
          selectedEmployee={selectedEmployee}
          fetchCompanyEmployees={fetchCompanyEmployees}
        />
      )}
      {
        showEmployeeLocationModal && <EmployeeLocationModal
          visible={showEmployeeLocationModal}
          onClose={handleCloseLocationModal}
          employee={employeeLoationDetails}
        />
      }
      {
        showUserTrackingModal && <UserTrackingModal
          visible={showUserTrackingModal}
          onClose={handleCloseUserTrackingModal}
          employee={userTrackingDetails}
        />
      }
      {showHoursModal && (
        <EmployeeHoursModal
          show={showHoursModal}
          onClose={handleCloseHours}
          employee={selectedEmployee}
        />
      )}
      <WorkDateSelector
        employee_id={workRequestEmployeeId}
        wfhWorkDates={workRequestDates}
        onRefresh={fetchCompanyEmployees}
        setOpenModalAction={setOpenWorkRequestModal}
      />
      <Loader show={loading.show} loadingMessage={loading.message} />
      {/* Bulk Generate Salary Modal */}
      <BulkGenerateSalaryModal
        show={showBulkSalaryModal}
        onClose={() => setShowBulkSalaryModal(false)}
      />
      <TerminateEmployeeModal
        Name="Withdraw Termination"
        confirmDelete={withdrawSeparation}
        btnName={terminationLoading ? "Withdrawing...." : "Withdraw"}
        show={showModalTermination}
        onClose={() => setShowModalTermination(false)}
        terminationLoading={terminationLoading}
      />
    </div>
  );
};

export default EmployeeList;
